(function() {
	'use strict';

	angular.module('app.dashboard')
	.config(inventoryActionResultsConfig);


	function inventoryActionResultsConfig (dashboardProvider) {
		// register widget
		dashboardProvider.widget(
			'inventoryActionResults', {
				name: 'Inventory Action Results',
				description: 'The value of Inventory Actions by status, grouped by reporting period.',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/inventory-actions-status.jpg',
				categories: ['All', 'Inventory'],
				config: {},
				slideshowView: true,
				isActive: true,
				controller: 'inventoryActionResultsCtrl',
				templateUrl: '/application/f/dashboard/widgets/inventory-action-results.html',
				drillDownUrl: '',
				reload: true,
				isDrillDown: true,
				isEditable: true,
				resolve: {
					timePeriodRadioOption: function (config) {
						if (config.timePeriodRadioOption) {
							return config.timePeriodRadioOption;
						}
						return 'past';
					},
					pastTimePeriodValue: function (config) {
						if (config.pastTimePeriod) {
							return config.pastTimePeriod;
						}
						return 'all';
					},
					futureTimePeriodValue: function (config) {
						if (config.futureTimePeriod) {
							return config.futureTimePeriod;
						}
						return 'all';
					},
					customDateOne: function (config) {
						if (config.customDateOne) {
							return config.customDateOne;
						}
						return new Date();
					},
					customDateTwo: function (config) {
						if (config.customDateTwo) {
							return config.customDateTwo;
						}
						return new Date();
					}
				}
			}
		);
	}
})();
